import {_, React, observer, IDisposer, useEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {Button, Menu, MenuItem} from '@blueprintjs/core'
import {FilterChipMenu, FilterChipsMenuItems, FilterChipStore, FilterChipStoreContext, FilterWithSelection, useVipLocalStore, VipLocalStore} from '@modules'
import {ISectionConfig, StoresInstance} from '@stores'
import * as css from './SectionFilterDropdownChip.css'

/// region Store

export class SectionFilterDropdownChipStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  get section() { return this.props.section}

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const SectionFilterDropdownChipStoreContext = React.createContext<SectionFilterDropdownChipStore>(null)
export const useSectionFilterDropdownChipStore = () => React.useContext(SectionFilterDropdownChipStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  section?: ISectionConfig
  filters: Array<FilterWithSelection>
}

import * as filterChipCss from '../chips/FilterChip.css'

export const SectionFilterDropdownChip = observer<MyProps>(function SectionFilterDropdownChip({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new SectionFilterDropdownChipStore(stores, obsProps)),
    {section, props: {filters}, catalog: {labelForField}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <SectionFilterDropdownChipStoreContext.Provider value={store}>
      <Popover2
        className={classNames(css.root, filterChipCss.root, className)}
        interactionKind='hover'
        usePortal={false}
        key={'menu'}
        minimal
        position='bottom-left'
        content={<Menu>
          {filters.map((f, i) => {
            return <FilterChipMenuItem info={f} key={i} />
          })}
        </Menu>}
        >
        <Button
          rightIcon='caret-down'
          minimal
          role='button'
          className={filterChipCss.chipButton}
          text={`${section.label} Filters (${filters.length})`}/>
      </Popover2>
    </SectionFilterDropdownChipStoreContext.Provider>)
})

/// endregion

export const FilterChipMenuItem = observer<{info: FilterWithSelection}>(function FilterChipMenuItem({info}) {
  const obsProps = useAsObservableSource({key: info.group}),
    store = useVipLocalStore((ws) => new FilterChipStore(ws, obsProps)),
    {filterField, field, state: {selected}} = info

   return (<FilterChipStoreContext.Provider value={store}>
     <MenuItem text={`${field.label}${false && selected.size > 1 ? ` (${selected.size})` : ''}`}>
       <FilterChipsMenuItems />
     </MenuItem>
   </FilterChipStoreContext.Provider>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/FilterChipsToolbar/CatalogFilters/SectionFilterDropdownChip.tsx